export class ItemOrderHistoryLine{
    constructor(
        public readonly id: number,
        public readonly status: number,
        public readonly date: string,
        public readonly orderDate: string,
        public readonly planArriveDate: string,
        public readonly supplierCode: string,
        public readonly initialOrder: number,
        public readonly sentOrder: number,
        public readonly confirmedOrder: number,
        public readonly orderArriveDate: string,
        public readonly itInputDate: string,
        public readonly arrivedQuantity: number,
        public readonly cancelCode: number,
        public readonly documentNo: string
    ){

    }
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/item-order-history/item-order-history-line.ts